var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-container"},[_c('keep-alive',[_c(_vm.currentComponent,{ref:"currentComponentRef",tag:"component",attrs:{"chatData":_vm.selectedChatData,"friendData":_vm.selectedFriendData},on:{"showChat":_vm.showChatView,"showFriend":_vm.showFriendView,"backToInbox":_vm.backToInbox}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }